// extracted by mini-css-extract-plugin
export var dropdown = "_ik-0";
export var imagePlaceholder = "_ik-2";
export var imageWrapper = "_ik-3";
export var productImage = "_ik-1";
export var truncateContainer = "_ik-4";
export var truncateText = "_ik-5";